module.exports = __webpack_public_path__ + "static/media/handStrength2Right.dd55efa9.png";